import { Component, inject, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StatsAiStateService } from '../../controller/stats-ai-state.service';

@Component({
  selector: 'app-stats-ai-video-selector',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './stats-ai-video-selector.component.html',
  styleUrls: ['./stats-ai-video-selector.component.scss']
})
export class StatsAiVideoSelectorComponent {
  public state = inject(StatsAiStateService);
  @Output() pageChanged = new EventEmitter<number>();
  @Output() analyzeClicked = new EventEmitter<void>();

  get teamVideos() {
    return this.state.teamVideos();
  }

  get selectedIds() {
    return this.state.selectedVideoIds();
  }
  
  get isLoading() {
    return this.state.isLoading();
  }

  isSelected(videoId: string): boolean {
    return this.selectedIds.includes(videoId);
  }

  toggleSelection(videoId: string): void {
    this.state.toggleVideoSelection(videoId);
  }

  selectAll(): void {
    this.state.selectAllVideos();
  }

  clearSelection(): void {
    this.state.clearSelection();
  }

  onPageChange(event: PageEvent): void {
    // el event.pageIndex empieza en 0
    this.pageChanged.emit(event.pageIndex + 1);
  }
}
